"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const menu_button_1 = require("@reach/menu-button");
require("@reach/menu-button/styles.css");
require("react");
require("../display-qr-button.types");
exports.Dropdown = (0, theme_1.styled)(menu_button_1.MenuList) `
  ${(props) => props.theme.common['box-shadow']};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 12px;
  width: ${(props) => `${props.width || 248}px`};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.common.radius};
  border: none !important;
`;
